
import commonfunctions from "../../Resources/commonfunctions";

export default {
    name: 'ShopSettings',
    mixins: [commonfunctions],
    data () {
        return {
            product:{},
        }
    },

    components: {
        
    },
     
    methods: {

        setPage(){
            this.product = this.$store.getters['account/getProduct'];
            if(Object.keys(this.product).length > 0){
                //get product details
            }
        },

      
    },

    created: function(){
        this.setMenuTabView('business','manageBusiness','',''); //default viewthis.setPage();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Account/Sellpoint/Settings/script.js